'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /** @jsx dom */


var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _dekuGoogleMaps = require('@viskan/deku-google-maps');

var _dekuGoogleMaps2 = _interopRequireDefault(_dekuGoogleMaps);

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

var _themes = require('../themes');

var themes = _interopRequireWildcard(_themes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var render = function render(_ref) {
	var props = _ref.props;

	var latitude = parseFloat(props.lat);
	var longitude = parseFloat(props.lng);
	var zoom = parseInt(props.zoom, 10);

	var settings = {
		apiKey: props.apiKey,
		description: props.description,
		header: props.header,
		height: props.height,
		icon: props.icon,
		image: props.image,
		lat: latitude,
		lng: longitude,
		theme: themes[props.theme],
		title: props.title,
		zoom: zoom
	};

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)(
		'div',
		null,
		(0, _magicVirtualElement2.default)(_dekuGoogleMaps2.default, _extends({ styleClasses: props.styleClasses }, settings))
	), props);
};

exports.default = { render: render };